import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import IMask from 'imask';

const MODULE = document.querySelectorAll('[data-module="contato_form"]');
const RECAPTCHA_ACTION = 'formulario_contato';

const MESSAGES = {
    invalid: 'Os campos sinalizados são obrigatórios.',
    success: 'Sua mensagem foi enviada com sucesso.',
    error: 'Não foi possível enviar sua mensagem. Tente novamente.',
};

class ContatoForm {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach((component, index) => {
            const form = component.querySelector('[data-contato-form]');
            if (!form) return;

            if (!form.id) {
                form.id = `contato-form-${index}`;
            }

            this.status = form.querySelector('[data-form-status]');

            new Bouncer(`#${form.id}`, {
                fieldClass: 'error',
                errorClass: 'error-message',
                disableSubmit: true,
                messageAfterField: true,
                messages: {
                    missingValue: {
                        checkbox: 'Campo de preenchimento obrigatório',
                        select: 'Campo de preenchimento obrigatório',
                        default: 'Campo de preenchimento obrigatório',
                    },
                    patternMismatch: {
                        email: 'Por favor, insira um e-mail válido',
                        default: 'Formato inválido',
                    },
                },
                emitEvents: true,
            });

            const telefone = form.querySelector('[name="telefone"]');
            if (telefone) {
                IMask(telefone, { mask: '(00) 00000-0000' });
            }

            form.addEventListener('bouncerFormInvalid', () => {
                this.showStatus(MESSAGES.invalid, 'error');
                if (navigator.vibrate) {
                    navigator.vibrate([100, 50, 100]);
                }
            });

            form.addEventListener('bouncerFormValid', event => this.handleSubmit(event, form));
        });
    }

    async handleSubmit(event, form) {
        event.preventDefault();

        const button = form.querySelector('[type="submit"]');
        const recaptchaInput = form.querySelector('input[name="recaptcha_token"]');
        const recaptchaActionInput = form.querySelector('input[name="recaptcha_action"]');

        if (recaptchaActionInput) {
            recaptchaActionInput.value = RECAPTCHA_ACTION;
        }

        this.hideStatus();
        button.setAttribute('disabled', 'disabled');
        button.dataset.label = button.innerText;
        button.innerText = 'Enviando...';

        const sendForm = async () => {
            const formData = new FormData(form);
            const payload = {};
            formData.forEach((value, key) => {
                payload[key] = value;
            });

            const response = await axios.post(
                `${AppSettings.baseApiUrl}basedigital/v1/formulario-contato/`,
                payload,
                { headers: { 'Content-Type': 'application/json' } }
            );

            this.resetButton(button);

            if (response.status === 200) {
                form.reset();
                this.showStatus(MESSAGES.success, 'success');
            } else {
                this.showStatus(MESSAGES.error, 'error');
            }
        };

        try {
            if (typeof window.reloadCaptcha === 'function') {
                window.reloadCaptcha(RECAPTCHA_ACTION, 'recaptcha_token', async token => {
                    if (recaptchaInput) {
                        recaptchaInput.value = token;
                    }

                    try {
                        await sendForm();
                    } catch (error) {
                        this.resetButton(button);
                        this.showStatus(MESSAGES.error, 'error');
                        console.error('Erro ao enviar o formulário de contato:', error);
                    }
                });
            } else {
                await sendForm();
            }
        } catch (error) {
            this.resetButton(button);
            this.showStatus(MESSAGES.error, 'error');
            console.error('Erro ao enviar o formulário de contato:', error);
        }
    }

    resetButton(button) {
        button.removeAttribute('disabled');
        button.innerText = button.dataset.label || 'Enviar mensagem';
    }

    showStatus(message, type) {
        if (!this.status) return;
        this.status.textContent = message;
        this.status.classList.remove('hidden', 'text-branco', 'text-principal');
        this.status.classList.add(type === 'success' ? 'text-branco' : 'text-principal');
    }

    hideStatus() {
        if (!this.status) return;
        this.status.textContent = '';
        this.status.classList.add('hidden');
    }
}

(() => {
    if (MODULE.length) {
        new ContatoForm();
    }
})();

export default ContatoForm;
